<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1gvVhN/tc-custom/9780743419673.jpg?1730532163894" alt="This image is the cover for the book Final Reflection, Star Trek: The Original Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Final Reflection, Star Trek: The Original Series
      </h1>
      <p class="bookDescription body article font2">
        <p>Klingon Captain Krenn is a ruthless war strategist. But on a mission to Earth, Krenn learns a lesson in peace. Suddenly he must fight a secret battle of his own. His empire has a covert plan to shatter the Federation. Only Krenn can prevent a war -- at the risk of his own life!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John M. Ford
      </h2>
      
      <p class="authorDescription body article">John M. Ford (1957&ndash;2006)&#160;was a&#160;science fiction and&#160;fantasy&#160;author,&#160;game designer, and poet. Some of his books include the&#160;<I>Star Trek&#160;</I>tie-in novels,&#160;<I>How Much for Just the Planet?&#160;</I>and <I>The Final Reflection.&#160;</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?789285cd